//@see https://github.com/mjrussell/redux-auth-wrapper

import authWrapper  from 'redux-auth-wrapper/connectedAuthWrapper';
import React, { Component } from 'react';
import * as roles from './roles';
import * as rulesCreator from './accessRulesCreator';

// create access rules

const partnerRules = rulesCreator.createSettingsForRole(roles.PARTNER_ROLE);

const memberRules = rulesCreator.createSettingsForRole(roles.MEMBER_ROLE);

const fbgEmployeesRules = rulesCreator.createSettingsForRole([roles.FBG_EDITORIAL_USER, roles.FBG_SALES_REP, roles.FBG_WEBMASTER]);

const fbgWMRules = rulesCreator.createSettingsForRole(roles.FBG_WEBMASTER);

const salesRules = rulesCreator.createSettingsForRole(roles.FBG_SALES_REP);

const fbgWebMasterAndSalesRules = rulesCreator.createSettingsForRole([roles.FBG_WEBMASTER, roles.FBG_SALES_REP]);

const superAdminRules = rulesCreator.createSettingsForRole(roles.SUPER_ADMINISTRATOR);

// FIXME delete, need for analytics page
const allAccessRules = rulesCreator.createSettingsForRole([roles.FBG_WEBMASTER, roles.FBG_SALES_REP, roles.PARTNER_ROLE]);

// create HOC's and export them

export const authenticatedAccess = authWrapper(rulesCreator.accessDefaults);

export const partnerAccess = authWrapper(partnerRules);

export const memberAccess = authWrapper(memberRules);

export const fbgAccess = authWrapper(fbgEmployeesRules);

export const fbgWebMasterAccess = authWrapper(fbgWMRules);

export const salesAccess = authWrapper(salesRules);

export const fbgWebMasterAndSalesAccess = authWrapper(fbgWebMasterAndSalesRules);

export const superAdminAccess = authWrapper(superAdminRules);

// FIXME delete, need for analytics page
export const allAccess = authWrapper(allAccessRules);

export const notMaskinstationerMini = authWrapper(rulesCreator.notMaskinstationerMini);

export const notMaskinbladetUser = authWrapper(rulesCreator.notMaskinbladetUser);

export const onlyMaskinstationerRegular = authWrapper(rulesCreator.onlyMaskinstationerRegular);
export const onlyMaskinstationer = authWrapper(rulesCreator.onlyMaskinstationer);


// WEBPACK FOOTER //
// ./web/src/services/access/index.js